import { render, staticRenderFns } from "./PreviousPaymentsWidget.vue?vue&type=template&id=72035b27&scoped=true&"
import script from "./PreviousPaymentsWidget.vue?vue&type=script&lang=js&"
export * from "./PreviousPaymentsWidget.vue?vue&type=script&lang=js&"
import style0 from "./PreviousPaymentsWidget.vue?vue&type=style&index=0&id=72035b27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72035b27",
  null
  
)

export default component.exports